module.exports = __webpack_public_path__ + "static/img/live-bg-3.371e901e.jpg";